export function percent( current, total ) {
  if(!current) return 0
  return Math.round( current * 100 / total)
}
